import React from 'react';

const StatsCard = ({ title, value, icon, trend }) => {
  return (
    <div className="bg-white p-6 rounded-xl shadow-sm">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-500">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
        </div>
        <div className="p-3 rounded-lg bg-blue-50 text-blue-600">
          {icon}
        </div>
      </div>
      {trend && (
        <div className="mt-2">
          <span className={`text-sm font-medium ${trend.color}`}>
            {trend.value} {trend.text}
          </span>
        </div>
      )}
    </div>
  );
};

export default StatsCard;